<div style="padding: 0; position: relative" class="buyer_info_container">
  <div style="padding: 20px;" class="border-bottom">
    <h4 style=" margin-bottom: 0; margin-top: 0">Create a buyer for property {{data.property.unitNum}}</h4>
  </div>
  <div style="padding: 20px; height: 500px; overflow-y: scroll">
    <form [formGroup]="buyerInfoForm">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Title</mat-label>
        <mat-select formControlName="title">
          <mat-option [value]=1>Mr.</mat-option>
          <mat-option [value]=2>Miss</mat-option>
          <mat-option [value]=3>Mrs.</mat-option>
          <mat-option [value]=4>Dr.</mat-option>
          <mat-option [value]=0>Company</mat-option>
        </mat-select>
        <!--        <mat-error *ngIf="f.title.errors && f.title.errors.required">-->
        <!--          Title is required-->
        <!--        </mat-error>-->
      </mat-form-field>
      <div style="display: flex; justify-content: space-between">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>{{this.buyerInfoForm.get('title').value !== 0 ? 'Surname' : 'Company name'}}</mat-label>
          <input matInput formControlName="lastName">
          <mat-error *ngIf="f.lastName.errors && f.lastName.errors.required">
            This field is required
          </mat-error>
          <mat-error
            *ngIf="!buyerInfoForm.get('lastName').hasError('pattern') && (!buyerInfoForm.hasError('minLength', 'lastName') &&  !buyerInfoForm.hasError('maxLength', 'lastName'))">
            Surname / company name length should be {{constants.MIN_LASTNAME_LENGTH}} -
            {{constants.MAX_LASTNAME_LENGTH}}
          </mat-error>
          <mat-error *ngIf="buyerInfoForm.get('lastName').hasError('pattern')">
            Please enter a valid surname or company name
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%" *ngIf="this.buyerInfoForm.get('title').value !== 0">
          <mat-label>Given name</mat-label>
          <input matInput formControlName="firstName">
          <mat-error
            *ngIf="!buyerInfoForm.get('firstName').hasError('pattern') && (!buyerInfoForm.hasError('minLength', 'firstName') &&  !buyerInfoForm.hasError('maxLength', 'firstName'))">
            Given name length should be {{constants.MIN_FIRSTNAME_LENGTH}} - {{constants.MAX_FIRSTNAME_LENGTH}}
          </mat-error>
          <mat-error *ngIf="buyerInfoForm.get('firstName').hasError('pattern')">
            Please enter a valid given name
          </mat-error>
        </mat-form-field>
      </div>
      <div style="display: flex; justify-content: space-between">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email">
          <mat-error *ngIf="f.email.errors && f.email.errors.required">
            Email is required
          </mat-error>
          <mat-error
            *ngIf="!buyerInfoForm.hasError('maxLength', 'email') && !buyerInfoForm.get('email').hasError('pattern') && f.email.errors && !f.email.errors.required">
            Email maximum length is {{constants.MAX_EMAIL_LENGTH}}
          </mat-error>
          <mat-error
            *ngIf="buyerInfoForm.get('email').hasError('pattern') && f.email.errors && !f.email.errors.required">
            Please enter a valid email
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phoneNumber">
          <mat-error *ngIf="f.phoneNumber.errors && f.phoneNumber.errors.required">
            Phone is required
          </mat-error>
          <mat-error
            *ngIf="!buyerInfoForm.hasError('maxLength', 'phoneNumber') && !buyerInfoForm.get('phoneNumber').hasError('pattern') && f.phoneNumber.errors && !f.phoneNumber.errors.required">
            Phone length should be {{constants.MIN_PHONE_NUMBER_LENGTH}} - {{constants.MAX_PHONE_NUMBER_LENGTH}}
          </mat-error>
          <mat-error
            *ngIf="buyerInfoForm.get('phoneNumber').hasError('pattern') && f.phoneNumber.errors && !f.phoneNumber.errors.required">
            Please enter a valid phone
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <h4>Buyer address</h4>
        <app-auto-complete (setAddress)="getAddress($event)" addressType="geocode" [style]="style"></app-auto-complete>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Street</mat-label>
            <input matInput formControlName="street">
            <mat-error *ngIf="!buyerInfoForm.hasError('maxLength', 'street')">
              Street maximum length is {{constants.MAX_ADDRESS_LINE2_LENGTH}}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Suburb</mat-label>
            <input matInput formControlName="suburb">
            <mat-error *ngIf="!buyerInfoForm.hasError('maxLength', 'suburb')">
              Suburb maximum length is {{constants.MAX_AREA_LENGTH}}
            </mat-error>
          </mat-form-field>
        </div>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>State</mat-label>
            <input matInput formControlName="state">
            <mat-error *ngIf="!buyerInfoForm.hasError('maxLength', 'state')">
              State maximum length is {{constants.MAX_STATE_LENGTH}}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label>Postcode</mat-label>
            <input matInput formControlName="postCode">
            <mat-error *ngIf="!buyerInfoForm.hasError('maxLength', 'postCode')">
              Postcode maximum length is {{constants.MAX_POSTCODE_LENGTH}}
            </mat-error>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Country</mat-label>
          <input matInput formControlName="country">
          <mat-error *ngIf="!buyerInfoForm.hasError('maxLength', 'country')">
            Country maximum length is {{constants.MAX_COUNTRY_LENGTH}}
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <h4>Buyer type</h4>
        <h4
          [ngStyle]="{color: submitted && f.firb.errors ? '#f44336' : '#DEDEDE', marginTop: '0', marginBottom: '10px', fontFamily: 'Poppins Regular'}">
          FIRB *</h4>
        <mat-radio-group formControlName="firb" (change)="firbChanged($event)">
          <mat-radio-button [value]=1 style="margin-right: 40px">Yes</mat-radio-button>
          <mat-radio-button [value]=0>No</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="f.firb.value === 0">
          <mat-radio-group formControlName="isLocalInvestor" style="margin-bottom: 20px">
            <h4
              [ngStyle]="{color: submitted && f.isLocalInvestor.errors ? '#f44336' : '#000', fontFamily: 'Poppins Regular', marginBottom: '10px'}">
              Is buyer a local investor? *</h4>
            <mat-radio-button [value]=1 style="margin-right: 40px">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]=0>
              No
            </mat-radio-button>
          </mat-radio-group>
          <mat-radio-group formControlName="isLocalFirstHomeBuyer" style="margin-bottom: 20px">
            <h4
              [ngStyle]="{color: submitted && f.isLocalFirstHomeBuyer.errors ? '#f44336' : '#000', fontFamily: 'Poppins Regular', marginTop: '20px', marginBottom: '10px'}">
              Is buyer a local first home buyer? *</h4>
            <mat-radio-button [value]=1 style="margin-right: 40px">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]=0>
              No
            </mat-radio-button>
          </mat-radio-group>
          <mat-radio-group formControlName="isLocalDownsize" style="margin-bottom: 20px">
            <h4
              [ngStyle]="{color: submitted && f.isLocalDownsize.errors ? '#f44336' : '#000', fontFamily: 'Poppins Regular', marginTop: '20px', marginBottom: '10px'}">
              Is buyer a local downsize buyer? *</h4>
            <mat-radio-button [value]=1 style="margin-right: 40px">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]=0>
              No
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <button mat-button (click)="submit()"
        style="position: absolute; top: -5px; right: 15px; background: #161616; color: #dedede;  margin-top: 20px; margin-bottom: 0;border:1px solid #dedede">
        Submit
      </button>
    </form>
  </div>
</div>